import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#FFF8F0]">
      {/* Header */}
      <header className="bg-white shadow-sm py-4 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-[#FF6B00] hover:text-[#E65C00] transition-colors">
            <ArrowLeft size={20} />
            <span className="font-medium">Back to Home</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-black text-[#1A1C19] mb-8" style={{ fontFamily: "Fraunces, serif" }}>
          Terms of Service
        </h1>
        
        <div className="prose prose-lg max-w-none text-[#4A5043]">
          <p className="text-sm text-gray-500 mb-8">Last Updated: February 2025</p>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">1. Agreement to Terms</h2>
            <p className="mb-4">
              By accessing or using our website and services, you agree to be bound by these Terms of Service 
              and all applicable laws and regulations. If you do not agree with any of these terms, you are 
              prohibited from using or accessing this site.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">2. Use License</h2>
            <p className="mb-4">
              Permission is granted to temporarily access the materials (information or software) on our website 
              for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer 
              of title, and under this license you may not:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or public display</li>
              <li>Attempt to decompile or reverse engineer any software contained on the website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
              <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">3. Product Information</h2>
            <p className="mb-4">
              We strive to provide accurate product descriptions and pricing. However, we do not warrant that 
              product descriptions or other content is accurate, complete, reliable, current, or error-free. 
              If a product offered by us is not as described, your sole remedy is to return it in unused condition.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">4. Health Disclaimer</h2>
            <p className="mb-4">
              The products and information on this website are not intended to diagnose, treat, cure, or prevent 
              any disease. The information provided is for educational purposes only and is not intended as medical 
              advice. Always consult with a qualified healthcare professional before starting any supplement program.
            </p>
            <p className="mb-4">
              Individual results may vary. Testimonials and reviews are not claimed to represent typical results. 
              Results in testimonials may not be typical and your results may vary.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">5. Ordering and Payment</h2>
            <p className="mb-4">
              By placing an order, you represent that you are of legal age in your jurisdiction and that all 
              information you provide is accurate. We reserve the right to refuse or cancel any order for any 
              reason, including but not limited to product availability, errors in product or pricing information, 
              or problems identified by our fraud detection systems.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">6. Shipping and Delivery</h2>
            <p className="mb-4">
              Shipping times are estimates and are not guaranteed. We are not responsible for delays caused by 
              shipping carriers, customs, or other factors outside our control. Risk of loss and title for items 
              purchased pass to you upon delivery of the items to the carrier.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">7. Limitation of Liability</h2>
            <p className="mb-4">
              In no event shall we or our suppliers be liable for any damages (including, without limitation, 
              damages for loss of data or profit, or due to business interruption) arising out of the use or 
              inability to use the materials on our website, even if we or an authorized representative has been 
              notified orally or in writing of the possibility of such damage.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">8. Indemnification</h2>
            <p className="mb-4">
              You agree to indemnify and hold harmless our company, its affiliates, officers, directors, employees, 
              agents, and suppliers from any claim or demand, including reasonable attorneys' fees, made by any 
              third party due to or arising out of your breach of these Terms of Service or your violation of any 
              law or the rights of a third party.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">9. Governing Law</h2>
            <p className="mb-4">
              These terms and conditions are governed by and construed in accordance with the laws and you 
              irrevocably submit to the exclusive jurisdiction of the courts in that location.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">10. Changes to Terms</h2>
            <p className="mb-4">
              We reserve the right to revise these terms of service at any time without notice. By using this 
              website, you are agreeing to be bound by the then-current version of these Terms of Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#1A1C19] mb-4">11. Contact Information</h2>
            <p className="mb-4">
              Questions about the Terms of Service should be sent to us at:
            </p>
            <p className="mb-4">
              <Link to="/contact" className="text-[#FF6B00] hover:underline">Visit our Contact Page</Link>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#1A1C19] text-white py-6 text-center text-sm">
        <p>© {new Date().getFullYear()} All rights reserved.</p>
      </footer>
    </div>
  );
};

export default TermsOfService;
